<ul class="category-list row">
  @for (category of categories(); track category) {
  <li class="category-list-item col-6 col-lg-4">
    <ish-category-tile  ishCategoryContext [uniqueId]="category" />
  </li>
  }
</ul>
